import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Modal, ModalHeader,  ModalBody, ModalFooter,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import BureauReport from "./BureauReport";
import BankingCredit from "./Banking";
import Payout from "./Payout";
import PanCredit from "./PanValidation";
import PennyDropCard from "./PennyDrop";
import RuleEngine from "./RuleEngine";
import NamesMatch from "./NamesMatch";
import Foir from "./Foir";
 import BlockArea from "./BlockArea";
 import { useParams } from "react-router-dom";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import { CONSTANTS } from "../../constants";
import {isLoggedIn} from '../../util/common.js'
import { useNavigate } from 'react-router-dom';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {getCreditComments, updateLoanStatus, fetchCreditDetails, calculateEmi, fetchRestructureDetails} from '../../services/customer.js';
import { toast } from 'react-toastify';

const Credit = ({ summaryOnly = false }) => {

  const logged = isLoggedIn();
  const navigate = useNavigate();
  const { cid , lid } = useParams();
  // let showApprovalSection = "no";
  const [selectedLoanStatusValue, setselectedLoanStatusValue] = useState('');
  const [loanStatusList, setLoanStatusList] = useState([]);
  const [repaymentTypeList, setRepaymentTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  const [creditData, setCreditData] = useState([]);
  const [isEditMode, setEditMode] = useState(false);
  const [approvalEdit, setApprovalEdit] = useState(false);
  const [comments, setComments] = useState([]);
  const [emiData, setEmiData] = useState({});
  const [tenureType, setTenureType] = useState("");
  const [maxEmi, setMaxEmi] = useState("");
  const [softApprovalData, setSoftApprovalData] = useState(null);
  const [lspData, setLspData] = useState(null);
const [lspLoading, setLspLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
const [editForm, setEditForm] = useState({
  roi: "",
  tenure: "",
  processingFee: "",
  softApproval: "",
  repaymentType: ""
});

  const [softApprovalLoading, setSoftApprovalLoading] = useState(false);
  const loanStatusUrls = {
    '1': URL.NEW_LOAN,
    '2': URL.INCOMPLETE_LOAN,
    '4': URL.APPROVE_LOAN,
    '5': URL.DISBURSE_LOAN,
    '3': URL.REJECT_LOAN,
    '6': URL.CLOSE_LOAN,
    '8': URL.CANCEL_LOAN,
    '9': URL.RESTRUCTURE_LOAN,
    '7': URL.WRITTEN_OFF_LOAN
  };
  const handleLoanStatusChange = (event) => {
    let selectedValue = event.target.value;
    selectedValue = parseInt(selectedValue);
    setselectedLoanStatusValue(selectedValue);
    if (selectedValue === CONSTANTS.LOAN_STATUS.APPROVE_LOAN || selectedValue === CONSTANTS.LOAN_STATUS.RESTRUCTURED){
      setApprovalEdit(true);
    }else{
      setApprovalEdit(false);
    }
    if (selectedValue === CONSTANTS.LOAN_STATUS.RESTRUCTURED){
      getRestructureDetails();
    }
  };
  const [tempApprovalData, setTempApprovalData] = useState({});

    const [approvalData, setApprovalData] = useState({
      approvedAmount: '',
      approvedTenure: '',
      roi: '',
      processingFeesRate: '',
      otherFees: '',
      otherFeesType: '',
      disbursalDate: '',
      productCode: '',
      productId: '',
      remark:'',
      rejectReason : '',
      loanStatus:'',
      disbursalAmount: '',
      processingFees: '',
      advanceEmi: '',
      gst: '',
      sgst: '',
      igst: '',
      cgst: '',
      roiType : '',
      paymentFrequency : '',
      calculateGstOnOtherFees : false,
      emiDate : '',
    });
  const handleInputChange = (key, value) => {
    setApprovalData(prev => ({
      ...prev,
      [key]: value
    }));
    if(key === "paymentFrequency"){
      findTenureType(value);
    }
  };
  const handleCheckBoxChange = (event) => {

    let value = event.target.checked ? 1 : 0;
    setApprovalData(prev => ({
      ...prev,
      [event.target.name]: value
    }));
    
  };
  function findTenureType(value){
    let tenureType = "";
      switch (value) {
        case '1':
          tenureType = "Days";
          break;
        case '2':
          tenureType = "Weeks";
          break;
        case '3':
          tenureType = "Months";
          break;
        case '4':
          tenureType = "Bullet";
          break;
        default:
          tenureType = ""; 
      }

      setTenureType(tenureType);
  }

  function getRepaymentText(value) {
  switch (value) {
    case 1:
      return "Daily";
    case 2:
      return "Weekly";
    case 3:
      return "Monthly";
    case 4:
      return "Bullet";
    default:
      return "null";
  }
}

    const fetchCombinedData = async () => {
  try {
  const response = await axiosInstance.get(`${URL.COMBINED_DETAILS}?customerId=${cid}&leadId=${lid}`);
  const result = response.data;
  setCreditData({
  bureauReport: result.bureauReport,
  banking: result.banking ,         
  panValidation: result.panValidation,       
  pennyDrop: result.pennyDrop,
  nameMatchAverage: result.nameMatchAverage,           
  foir: {
  dbr: result.foir
}                  
});

} catch (error) {
  toast.error("Error while fetching combined details: " + error.message, {
    autoClose: 4000,
    position: "bottom-center",
  });
}
};

  const fetchCreditData = async () => {
    try {
  const response = await axiosInstance.get(`${URL.CREDIT_DETAILS}?customer_id=${cid}&lead_id=${lid}`);

  if (response.data?.error) {
    toast.error(response.data.error, {
      autoClose: 4000,
      position: "bottom-center",
    });
      }else{
        setCreditData(response.data);

        setApprovalData(prev => ({
          ...prev,
          approvedAmount: response.data.lead?.loanAmount ?? '',
          approvedTenure: response.data.lead?.tenure ?? '',
          roi: response.data.lead?.roi ?? '2',
          processingFeesRate: response.data.lead?.processingFee ?? '',
          otherFees: response.data.lead?.otherDeduction ?? '',
          otherFeesType: response.data.lead?.otherDeductionType ?? '',
          disbursalDate: (response.data.loan?.disbursedDate !== "") ? response.data.lead?.disbursedDate : '',
          productCode: response.data.lead?.productName ?? '',
          loanStatus: response.data.lead?.loanStatus ?? 1,
          
          disbursalAmount: response.data.loan?.disbursedAmount ?? '',
          processingFees: response.data.lead?.processingFee ?? '',
          advanceEmi: response.data.loan?.brokenAmount ?? '',
          gst: parseFloat(response.data.loan?.sgst ?? 0 ) + parseFloat(response.data.loan?.igst ?? 0) + parseFloat(response.data.loan?.cgst ?? 0),
          sgst: response.data.loan?.sgst ?? 0,
          igst: response.data.loan?.igst ?? 0,
          cgst: response.data.loan?.cgst ?? 0,
          remark : "",
          rejectReason: "",
          roiType : response.data.lead?.roiType ?? 1,
          paymentFrequency : response.data.loan?.repaymentType ?? 4,
          calculateGstOnOtherFees : response.data.lead?.isGstOnOtherFees ? true : false,
          emiDate : response.data.lead?.emiDate ?? ''
        }));
       
        findTenureType(response.data.lead?.repaymentType ?? "4");
        setselectedLoanStatusValue(response.data.lead?.customerStatus ?? 1);
        setLoanStatusList(response.data.customer_status_list ?? []);
        setRepaymentTypeList(response.data.repayment_type_list ?? []);

      }

    } catch (error) {
      toast.error("error while fetching credit details. "+error.message, {
        autoClose: 4000,
        position: "bottom-center",
      });
    }
  };

  useEffect(() => {
  const fetchSoftApproval = async () => {
    try {
      setSoftApprovalLoading(true);
      if (cid && lid) {
        const res = await axiosInstance.get(
          `${URL.LOAN_APPROVAL}?customerId=${cid}&leadId=${lid}`
        );
        if (res.status === 200 && res.data) {
          setSoftApprovalData(res.data);
        }
      }
    } catch (error) {
      console.error("Failed to fetch soft approval details", error);
    } finally {
      setSoftApprovalLoading(false);
    }
  };

  fetchSoftApproval();
}, [cid, lid]);

useEffect(() => {
  const fetchLspData = async () => {
    try {
      setLspLoading(true);
      if (cid && lid) {
        const res = await axiosInstance.get(
          `${URL.LSP_VIEW}?customerId=${cid}&leadId=${lid}`
        );
        if (res.status === 200 && res.data && res.data.editCount === 4) {
          setLspData(res.data);
          toast.success("LSP data fetched successfully!");
        }
      }
    } catch (error) {
      console.error("Failed to fetch LSP data", error);
      toast.error("Failed to fetch LSP data");
    } finally {
      setLspLoading(false);
    }
  };

  fetchLspData();
}, [cid, lid]);

const handleEditSalora = () => {
  setEditForm({
    roi: softApprovalData.roi,
    tenure: softApprovalData.tenure,
    processingFee: softApprovalData.processingFee,
    softApproval: softApprovalData.softApproval,
    repaymentType: softApprovalData.repaymentType
  });

  setEditModal(true);
};


 const handleSaveEdit = async () => {
  try {
    const res = await axiosInstance.post(
      `${URL.LOAN_APPROVAL_EDIT}?customerId=${cid}&leadId=${lid}`,
      editForm
    );

    toast.success(res.data.message || "Updated successfully!");

    // CLOSE POPUP
    setEditModal(false);

    // REFRESH VIEW AFTER EDIT
    setSoftApprovalData((prev) => ({
      ...prev,
      ...editForm
    }));

  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to update!");
  }
};


const handleLockForLsp = async () => {
  try {
    const res = await axiosInstance.post(
     `${URL.LOAN_APPROVAL_LOCK_FOR_LSP}?customerId=${cid}&leadId=${lid}`
    );

    toast.success(res.data.message || "Locked!");

  } catch (err) {
    toast.error(err.response?.data?.message || "Failed!");
  }
};



  useEffect(() => {
    if (!logged) {
      navigate('/auth/login'); 
    } else {
      fetchCombinedData();
      fetchCreditData();
    }
}, [navigate, logged]);

 const getRestructureDetails = async () => {
  let msg = "";
  try {
    const url = `${URL.RESTRUCTURE_DETAILS}?customerId=${cid}&leadId=${lid}`;
    const response = await axiosInstance.get(url);

    if (response.data?.error) {
      msg = response.data.error;
    } else if (response.data.status !== "success") {
      msg = "Error : " + response.data?.msg;
    } else {
      setApprovalData(prev => ({
        ...prev,
        approvedAmount: response.data.data.total_outstanding_principal ?? ''
      }));
    }
  } catch (error) {
    msg = "error while fetching restructure details. " + error.message;
  }

  if (msg) {
    toast.error(msg, {
      autoClose: 4000,
      position: "bottom-center",
    });
  }
};

const handleSoftApprove = () => {
  if (lspData) {
    setApprovalData(prev => ({
      ...prev,
      approvedAmount: lspData.softApproval ?? '',
      roi: parseFloat(lspData.roi) || '',
      approvedTenure: lspData.tenure ?? '',
      processingFeesRate: (lspData.processingFee ?? "").toString().replace('%', ''),
paymentFrequency: (lspData.repaymentType ?? ""),
      remark: 'Auto-approved using Soft Approval',
    }));

   

    // Hide Soft Approval Section
    setSoftApprovalData(null);

    // Set loan status to APPROVED (4)
    setselectedLoanStatusValue(CONSTANTS.LOAN_STATUS.APPROVE_LOAN);
    setApprovalEdit(true);
    setEditMode(true);

    toast.success("Soft approval details applied to the approval form", {
      autoClose: 3000,
      position: "bottom-center",
    });
  }
};

  const handleEdit = (e) => {
    e.preventDefault();
    setTempApprovalData({...approvalData});
    setEditMode(true);

    if (approvalData.loanStatus === CONSTANTS.LOAN_STATUS.APPROVE_LOAN || CONSTANTS.LOAN_STATUS.RESTRUCTURED){
      setApprovalEdit(true);
    }else{
      setApprovalEdit(false);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setApprovalData(prev => ({
      ...prev,
      ...tempApprovalData
    }));
    setEditMode(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const newErrors = validate();
    // Prevent submission if there are validation errors
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
      
      let payload = {
        leadId:             lid,
        customerId:         cid,
        remark:             approvalData.remark,
        status:             selectedLoanStatusValue
      }
      if ([CONSTANTS.LOAN_STATUS.APPROVE_LOAN, CONSTANTS.LOAN_STATUS.RESTRUCTURED].includes(selectedLoanStatusValue)) {
        payload.loanAmount=     Number(approvalData.approvedAmount);
        payload.tenure=     Number(approvalData.approvedTenure);
        payload.roi=                Number(approvalData.roi);
        payload.processingFeesRate= Number(approvalData.processingFeesRate);
        payload.otherFees=          Number(approvalData.otherFees);
        payload.disbursalDate=      approvalData.disbursalDate ? getDateFromPicker(approvalData.disbursalDate) : null;
        payload.productCode=        approvalData.productCode;
        
        payload.otherFeesType=      approvalData.otherFeesType;
        payload.roiType=            approvalData.roiType;
        payload.paymentFrequency=   approvalData.paymentFrequency;
        payload.emiDate=   approvalData.emiDate ? getDateFromPicker(approvalData.emiDate) : null;
        payload.calculateGstOnOtherFees=   Number(approvalData.calculateGstOnOtherFees);

      }else if ([CONSTANTS.LOAN_STATUS.DISBURSE_LOAN].includes(selectedLoanStatusValue)) {
        payload.disbursalDate=      approvalData.disbursalDate ? getDateFromPicker(approvalData.disbursalDate) : null;
      }else if ([CONSTANTS.LOAN_STATUS.REJECT_LOAN].includes(selectedLoanStatusValue)) {
        payload.rejectReason=      approvalData.rejectReason?? "";
      }
      

      let loanStatusUpdateUrl = loanStatusUrls[selectedLoanStatusValue.toString()].toString() || '';

      const data = {
        post_data : {
            ...payload
        },
        url : `${loanStatusUpdateUrl}?customer_id=${cid}&lead_id=${lid}`
      };
      let status = "";

      try {
        updateLoanStatus(data).then(response => {
          
          if (response.response && response.response.status === 200) {
            setEditMode(false);
            toast.success("saved", {
              autoClose: 4000,
              position: "bottom-center",
            });
          }else{
            status = "error";
            
            let msg = "Error updating Loan satus !";
            if (response.response){
              msg += "Status Code "+response.response.status
            }

            toast.error(msg, {
              autoClose: 4000,
              position: "bottom-center",
            });
          }
        }).catch(error => {
          status = "error";

          toast.error("Error updating Loan satus "+error.message , {
            autoClose: 4000,
            position: "bottom-center",
          });
        });
      } catch (error) {
        status = "error";
    
        toast.error("Error updating Loan satus: "+ error.message , {
          autoClose: 4000,
          position: "bottom-center",
        });
      }

      return status;
  };

  const getDateFromPicker = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const isoString = date.toISOString().split('T')[0];
      return isoString;
    }else{
      return date;
    }
  }
  
   // Validation function (only enforces rules when status is 4–10)
  const validate = () => {
    const newErrors = {};

    if ([CONSTANTS.LOAN_STATUS.APPROVE_LOAN].includes(selectedLoanStatusValue)) {
      // Remark validation
      if (!approvalData.remark.trim()) {
        newErrors.remark = 'Comment is required';
      }

      // Approved Amount validation
      if (!approvalData.approvedAmount) {
        newErrors.approvedAmount = 'Loan amount is required';
      } else if (isNaN(approvalData.approvedAmount)) {
        newErrors.approvedAmount = 'Loan amount must be a number';
      }else if (approvalData.approvedAmount <= 0) {
        newErrors.approvedAmount = 'Loan amount should be greater than 0';
      }

      // Approved Tenure validation
      if (!approvalData.approvedTenure) {
        newErrors.approvedTenure = 'Tenure is required';
      } else if (isNaN(approvalData.approvedTenure)) {
        newErrors.approvedTenure = 'Tenure must be a number';
      }else if (approvalData.approvedTenure <= 0) {
        newErrors.approvedAmount = 'Tenure should be greater than 0';
      }

      // ROI validation
      if (!approvalData.roi) {
        newErrors.roi = 'ROI is required';
      } else if (isNaN(approvalData.roi)) {
        newErrors.roi = 'ROI must be a number';
      }

      if (!approvalData.roiType) {
        newErrors.roiType = 'ROI Type is required';
      }
      if (!approvalData.paymentFrequency) {
        newErrors.paymentFrequency = 'Payment Frequency is required';
      }
      // Processing Fees Rate validation
      if (!approvalData.processingFeesRate) {
        newErrors.processingFeesRate = 'Processing fee rate is required';
      } else if (isNaN(approvalData.processingFeesRate)) {
        newErrors.processingFeesRate = 'Processing fee rate must be a number';
      }

      // Other Fees validation (only if filled)
if (approvalData.otherFees !== '' && approvalData.otherFees !== null) {
  if (isNaN(approvalData.otherFees)) {
    newErrors.otherFees = 'Other fees must be a number';
  } else if (Number(approvalData.otherFees) < 0) {
    newErrors.otherFees = 'Other fees cannot be negative';
  }
}


      // Other Fees validation
      if (approvalData.otherFees) {
        if (!approvalData.otherFeesType) {
          newErrors.otherFeesType = 'Other fees Type is required';
        }
      } 

      // Disbursal Date validation
      if (!approvalData.disbursalDate) {
        //newErrors.disbursalDate = 'Disbursal date is required';
      }

      // Product Code validation
      if (!approvalData.productCode) {
        newErrors.productCode = 'Product code is required';
      }
    }else if([CONSTANTS.LOAN_STATUS.REJECT_LOAN].includes(selectedLoanStatusValue)){
        if (!approvalData.rejectReason.trim()) {
          newErrors.rejectReason = 'Reject reason is required';
        }
    }else{
      if (!approvalData.remark.trim()) {
        newErrors.remark = 'Comment is required';
      }
    }

    setErrors(newErrors);
    return newErrors;
  };

  const [emiViewModal, setEmiViewModal] = useState(false);
  const [commentsModal, setCommentsModal] = useState(false);
  const [maxEmiModal, setMaxEmiModal] = useState(false);


  const calculateEmiForView = async (e) => {
    const newErrors = validate();
    if ("remark" in newErrors) {
      delete newErrors.remark;
    }
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setEmiViewModal(true);
      
    let payload = {
      leadId:             lid,
      customerId:         cid,
      remark:             approvalData.remark,
      status:             selectedLoanStatusValue
    }
    if ([CONSTANTS.LOAN_STATUS.APPROVE_LOAN].includes(selectedLoanStatusValue)) {
      payload.loanAmount=     Number(approvalData.approvedAmount);
      payload.tenure=     Number(approvalData.approvedTenure);
      payload.roi=                Number(approvalData.roi);
      payload.processingFeesRate= Number(approvalData.processingFeesRate);
      payload.otherFees=          Number(approvalData.otherFees);
      payload.disbursalDate=      approvalData.disbursalDate ? getDateFromPicker(approvalData.disbursalDate) : null;
      payload.productCode=        approvalData.productCode;
      
      payload.otherFeesType=      approvalData.otherFeesType;
      payload.roiType=            approvalData.roiType;
      payload.paymentFrequency=   approvalData.paymentFrequency;
      payload.emiDate=   approvalData.emiDate ? getDateFromPicker(approvalData.emiDate) : null;
      payload.calculateGstOnOtherFees=   Number(approvalData.calculateGstOnOtherFees);
      
    }else if ([CONSTANTS.LOAN_STATUS.DISBURSE_LOAN].includes(selectedLoanStatusValue)) {
      payload.disbursalDate=      approvalData.disbursalDate ? getDateFromPicker(approvalData.disbursalDate) : null;
    }else{

    }
    

    const data = {
      post_data : {
          ...payload
      },
      url : URL.CALCULATE_EMI+`?customer_id=${cid}&lead_id=${lid}`
    };
    let status = "";
    let error_msg
    try {
      let response = await calculateEmi(data);
      
      if (response.response && response.response.status === 200) {
        if(response.data.status === "success"){
          status = "success";
          setEmiData(response.data.data);

          let loan = response.data.data.loan;

          setApprovalData(prev => ({
            ...prev,
            disbursalAmount: loan.disbursedAmount,
            processingFees: loan.processingFee,
            advanceEmi: loan.brokenAmount,
            gst: (loan.sgst + loan.igst + loan.cgst) ,
            sgst: loan.sgst,
            igst: loan.igst,
            cgst: loan.cgst,
          }));

        }else{
          status = "error";
          error_msg = "Error fetching emi data! "+response.data.msg;
        }
        
      }else{
        status = "error";
        error_msg = "Error fetching emi data !";
        if (response.response){
          error_msg += "Status Code "+response.response.status
        }
      }
    } catch (error) {
      status = "error";
      error_msg = "Error fetching emi data: "+ error.message;
    }

    if(error_msg){
      toast.error(error_msg, {
        autoClose: 4000,
        position: "bottom-center",
      });
    }
    return status;
  };

  const handleViewEmiClick = (event) => {
    calculateEmiForView();
    
  };
  const closeViewEmiModal = () => {
    setEmiViewModal(false);
  };

  const showComments = async (event) => {
    setCommentsModal(true);
    await fetchCreditComments();
    
    
  };

  const closeCommentsModal = () => {
    setCommentsModal(false);
  };

  const fetchCreditComments = async () => {
    try {
      let data = {};
      data.url = URL.GET_COMMENTS+`?customer_id=${cid}&lead_id=${lid}&comment_type=2`;
      let response = await getCreditComments(data);
      if (response.error){
        toast.error(response.error, {
          autoClose: 4000,
          position: "bottom-center",
        });
      }else{
        setComments(response.data || []);
      }
    } catch (error) {
      toast.error("error while fetching credit comments. "+error.message, {
        autoClose: 4000,
        position: "bottom-center",
      });
    }
  };
  const getTenureUsingMaxEmi = async (event) => {
    setMaxEmiModal(true);
    let maxEmi_ = calculateMaxEmi({
      loanAmount : approvalData.approvedAmount,
      roi : approvalData.roi,
      roiType : approvalData.roiType,
      frequency : approvalData.paymentFrequency,
      tenure : approvalData.approvedTenure
    });
    if(maxEmi_){
      setMaxEmi(Math.ceil(maxEmi_));
    }
  };

  const closeMaxEmiModal = () => {
    setMaxEmiModal(false);
  };
  const calculateMaxEmi = ({ loanAmount, roi, roiType, frequency, tenure }) => {
    if(!(loanAmount && roi && roiType && frequency && tenure)){
      return "";
    }
    const periodsInYear = {
        1: 365,
        2: 52,
        3: 24,
        4: 12,
        5: 4,
        6: 2,
        7: 1
    };
    if (frequency === 8) {
        // Bullet Payment
        const interest = (loanAmount * roi * tenure) / (100 * 365);
        return loanAmount + interest; // Only 1 EMI
    }
    const period = periodsInYear[frequency];
    if (!period || tenure <= 0) return null;
    if (roiType === 1) {
        // Flat ROI
        const totalInterest = (loanAmount * roi * tenure) / (100 * period);
        const totalPayable = loanAmount + totalInterest;
        return totalPayable / tenure;
    } else {
        // Reducing ROI
        const r = roi / 100 / period;
        const numerator = loanAmount * r * Math.pow(1 + r, tenure);
        const denominator = Math.pow(1 + r, tenure) - 1;
        return numerator / denominator;
    }
}
  const calculateTenureFromMaxEmi = () => {
    setMaxEmiModal(false);
    let tenure = calculateMaxTenure({
      loanAmount : approvalData.approvedAmount,
      roi : approvalData.roi,
      roiType : approvalData.roiType,
      frequency : approvalData.paymentFrequency,
      maxExpectedEmi : maxEmi
    });
    setApprovalData(prev => ({
      ...prev,
      approvedTenure: tenure
    }));
  }
  const calculateMaxTenure = ({ loanAmount, roi, roiType, frequency, maxExpectedEmi }) => {
    if(!(loanAmount && roi && roiType && frequency && maxExpectedEmi)){
      return "";
    }
    const periodsInYear = {
        1: 365,
        2: 52,
        3: 24,
        4: 12,
        5: 4,
        6: 2,
        7: 1
    };

    if (frequency === 8) {
        // Bullet payment
        for (let tenure = 1; tenure <= 3650; tenure++) {
            const interest = (loanAmount * roi * tenure) / (100 * 365);
            const emi = loanAmount + interest;
            if (emi <= maxExpectedEmi) return tenure;
        }
        return null;
    }

    const period = periodsInYear[frequency];
    if (!period) return null;

    for (let tenure = 1; tenure <= 1000; tenure++) {
        let emi = 0;

        if (roiType === 1) {
            // Flat ROI
            const totalInterest = (loanAmount * roi * tenure) / (100 * period);
            emi = (loanAmount + totalInterest) / tenure;
        } else {
            // Reducing ROI
            const r = roi / 100 / period;
            emi = (loanAmount * r * Math.pow(1 + r, tenure)) / (Math.pow(1 + r, tenure) - 1);
        }

        if (emi <= maxExpectedEmi) return tenure;
    }

    return null;
}
  return (
    <>
<Modal id="maxEmiModal" isOpen={maxEmiModal} toggle={closeMaxEmiModal} size="lg" >
        <ModalHeader>
        Max Emi
        </ModalHeader>
        <ModalBody>
              <Row>
                <Col lg="12" className="mb-4">  
                      <FormGroup>
                        <label className="form-control-label">Max Emi</label>
                        <Input 
                          type="number"
                          placeholder="Max expected emi"
                          value={maxEmi}
                          onChange={(e) => setMaxEmi(e.target.value)}
                        />
                      </FormGroup>
                      <Button variant="primary" onClick={calculateTenureFromMaxEmi}>Calculate</Button>
                 </Col>
              </Row>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeMaxEmiModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal id="remarksModal" isOpen={commentsModal} toggle={closeCommentsModal} size="lg" >
        <ModalHeader>
           Credit Remarks
        </ModalHeader>
        <ModalBody>
              <Row>
              {comments.length > 0 ? (
                comments.map((comment, idx) => (
                <Col lg="12" className="mb-4"  key={idx}>
                      <div className="comment_w">
                        <label className="mr-4 italic comment-date"><i>Date : <b>{comment.create_date}</b></i></label>
                        <label  className="mr-4 comment-agent">Agent Name : <b>{comment.commented_by_username}</b></label>
                        <label className="comment-status">Loan Status : <b>{comment.status_value}</b></label>
                        <p className="comment-text">
                        {comment.comment}
                        </p>
                    </div>
                 </Col>

              ))
              ) : (
                <Col lg="12">
                  <p>No comments found.</p>
                </Col>
              )}
               
              </Row> 
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeCommentsModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>


<Modal isOpen={editModal} toggle={() => setEditModal(false)}>
  <ModalHeader toggle={() => setEditModal(false)}>
    Edit Soft Approval Details
  </ModalHeader>
  <ModalBody>
    <div className="mb-3">
      <label>ROI</label>
      <Input
        type="number"
        value={editForm.roi}
        onChange={(e) => setEditForm({ ...editForm, roi: e.target.value })}
      />
    </div>

    <div className="mb-3">
      <label>Tenure (Days)</label>
      <Input
        type="number"
        value={editForm.tenure}
        onChange={(e) => setEditForm({ ...editForm, tenure: e.target.value })}
      />
    </div>

    <div className="mb-3">
      <label>Processing Fee</label>
      <Input
        type="number"
        value={editForm.processingFee}
        onChange={(e) => setEditForm({ ...editForm, processingFee: e.target.value })}
      />
    </div>

    <div className="mb-3">
      <label>Loan Amount (softApproval)</label>
      <Input
        type="number"
        value={editForm.softApproval}
        onChange={(e) => setEditForm({ ...editForm, softApproval: e.target.value })}
      />
    </div>

    <div className="mb-3">
      <label>Repayment Type</label>
      <Input
        type="text"
        value={editForm.repaymentType}
        onChange={(e) => setEditForm({ ...editForm, repaymentType: e.target.value })}
      />
    </div>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={() => setEditModal(false)}>
      Cancel
    </Button>

    <Button color="primary" onClick={handleSaveEdit}>
      Save Changes
    </Button>
  </ModalFooter>
</Modal>


      <Modal id="emiViewModal" isOpen={emiViewModal} toggle={closeViewEmiModal} size="lg" >
        <ModalHeader>
            Emi Schedule
        </ModalHeader>
        <ModalBody>
              <Row>
              <Col lg="12">
                  <Row className="mb-1">     
                      <Col lg="4">
                        <label className="key_t3">Disbursal Amount : </label>
                        <label className="val_t3">{approvalData.disbursalAmount}</label>
                      </Col>

                      <Col lg="4">
                        <label className="key_t3">Processing Fees : </label>
                        <label className="val_t3">{approvalData.processingFees}</label>
                      </Col>

                      <Col lg="4">
                        <label className="key_t3">Advance Emi : </label>
                        <label className="val_t3">{approvalData.advanceEmi}</label>
                      </Col>
                  </Row> 

                  <Row className="mb-1">     
                      <Col lg="4">
                      <label className="key_t3">GST : </label>
                      <label className="val_t3">{approvalData.gst}</label>
                      </Col>

                      
                      <Col lg="4">
                      <label className="key_t3">SGST : </label>
                      <label className="val_t3">{approvalData.sgst}</label>
                      </Col>
                    
                        
                      <Col lg="4">
                      <label className="key_t3">IGST : </label>
                      <label className="val_t3">{approvalData.igst}</label>
                      </Col>
                  </Row> 

                  <Row className="mb-1">     
                        
                      <Col lg="5">
                      <label className="key_t3">CGST : </label>
                      <label className="val_t3">{approvalData.cgst}</label>
                      </Col>
                  </Row> 
                </Col> 
                  <Col lg="12">
                    <Table className="align-items-center table-flush" responsive>
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">Installment ID</th>
                          <th scope="col">Emi Amount</th>
                          <th scope="col">Principal</th>
                          <th scope="col">Interest</th>
                          <th scope="col">Installment Date</th>
                        </tr>
                      </thead>
                      <tbody>
                      {"repayments" in emiData && emiData.repayments.length > 0 ? (
                emiData.repayments.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.emiNumber}</td>
                          <td>{row.emiAmount}</td>
                          <td>{row.principal}</td>
                          <td>{row.interest}</td>
                          <td>{row.emiDate}</td>
                        </tr>
                        ))
                      ) : ""}
                      </tbody>
                    </Table>
                 </Col>
              </Row>     
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeViewEmiModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
          
          {/* Credit Header */}
            <Card className="bg-secondary shadow mb-5">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Credit</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row className="credit_boxw">
                  <BureauReport cid={cid} lid={lid} bureau_data={{ score: creditData.bureauReport }} />
                  <PanCredit cid={cid} pan_validation_data={creditData.panValidation === 1} />
                  {/* Payment view: penny drop always reads as success (Done). */}
                  <PennyDropCard cid={cid} penny_drop_data={summaryOnly ? true : creditData.pennyDrop === 1} forceSuccess={summaryOnly} />
                  {/* Payment view (summaryOnly) shows only Bureau + PAN + Penny Drop; the rest are hidden. */}
                  {!summaryOnly && (
                    <>
                      <BankingCredit cid={cid} banking_data={creditData.banking === 1} />
                      <RuleEngine cid={cid} lid={lid} rule_engine_data={creditData?.rule_engine} />
                      <NamesMatch cid={cid} lid={lid} name_validation_data={creditData?.name_validation} nameMatchAverage={creditData?.nameMatchAverage} />
                      <Foir cid={cid} lid={lid} foir_data={creditData?.foir} />
                      <Payout cid={cid} Payout_data={creditData.Payout === 1} />
                    </>
                  )}
                </Row>
              </CardBody>
            </Card>
          {/* Credit Header End */}
          {/* Loan / Soft Approval section hidden in all views. */}
          {false && (
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Loan</h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    {/* <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      Settings
                    </Button> */}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>

            {/* {softApprovalLoading ? (
  <p>Loading soft approval details...</p>
) : softApprovalData ? (
  <Card className="mb-4">
    <CardHeader>
      <h4>Soft Approval Details</h4>
    </CardHeader>
    <CardBody>
      <Row className="align-items-center mb-3">
        <Col md="3">
          <strong>Loan Amount:</strong> ₹{softApprovalData.softApproval ?? 'null'}
        </Col>
        <Col md="3">
          <strong>ROI:</strong> {softApprovalData.roi ?? 'null'}
        </Col>
        <Col md="3">
          <strong>Tenure:</strong> {softApprovalData.tenure ?? 'null'} Days
        </Col>
        <Col md="3">
          <strong>Processing Fee:</strong> {softApprovalData.processingFee ?? 'null'}
        </Col>
      </Row>
      <Button color="success" onClick={handleSoftApprove}>
        Approve This Offer
      </Button>
    </CardBody>
  </Card>
) : null} */}



{softApprovalLoading ? (
  <p>Loading soft approval details...</p>
) : softApprovalData ? (
  <Card className="mb-4">
    <CardHeader>
      <h4>Soft Approval Details</h4>
    </CardHeader>
    <CardBody>
      <Row className="align-items-center mb-3">
        <Col md="3">
          <strong>Loan Amount:</strong> ₹{softApprovalData.softApproval ?? 'null'}
        </Col>
        <Col md="3">
          <strong>ROI:</strong> {softApprovalData.roi ?? 'null'}
        </Col>
        <Col md="3">
          <strong>Tenure:</strong> {softApprovalData.tenure ?? 'null'} Days
        </Col>
        <Col md="3">
          <strong>Processing Fee:</strong> {softApprovalData.processingFee ?? 'null'}
        </Col>
      </Row>

      <Row className="align-items-center mb-3">
        <Col md="3" className="mt-3">
  <strong>Repayment Type:</strong> {getRepaymentText(softApprovalData.repaymentType)}
</Col>
      </Row>

      {/* ✅ EDIT BUTTON */}
      <Button color="primary" className="me-2" onClick={handleEditSalora}>
        Edit Details
      </Button>

      {/* ✅ LOCK FOR LSP BUTTON */}
      <Button color="success" onClick={handleLockForLsp}>
        Lock for LSP
      </Button>
    </CardBody>
  </Card>
) : null}

{softApprovalLoading ? (
  <p>Loading LSP Offered details...</p>
) : lspData ? (
  <Card className="mb-4 mt-4">
    <CardHeader>
      <h4>LSP Offered Details</h4>
    </CardHeader>
    <CardBody>
      <Row className="align-items-center mb-3">

        <Col md="3">
          <strong>Loan Amount:</strong> ₹{lspData.softApproval ?? "null"}
        </Col>

        <Col md="3">
          <strong>ROI:</strong> {lspData.roi ?? "null"}
        </Col>

        <Col md="3">
          <strong>Tenure:</strong> {lspData.tenure ?? "null"} Days
        </Col>

        <Col md="3">
          <strong>Processing Fee:</strong> {lspData.processingFee ?? "null"}
        </Col>
</Row>
<Row className="align-items-center mb-3">
        <Col md="3" className="mt-3">
  <strong>Repayment Type:</strong> {getRepaymentText(lspData.repaymentType)}
</Col>
</Row>

      

      {/* Only show Approve This Offer button if editCount === 4 */}
      {lspData.editCount === 4 && (
        <Button color="success" onClick={handleSoftApprove}>
          Approve This Offer
        </Button>
      )}
    </CardBody>
  </Card>
) : null}


                
              <Row className="">     
                <Col lg="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-state"
                    >
                      Loan Status
                    </label>
                    <select disabled={!isEditMode} value={selectedLoanStatusValue} onChange={handleLoanStatusChange} className="form-control" 
                    id="input-loan-status" name="loan_status">
                      <option value="">--Select Loan Status--</option>
                      {loanStatusList.map(option => (
                      <option key={option.value_id} value={option.value_id}>
                        {option.status_value}
                      </option>
                    ))}
                    </select>
                    
                  </FormGroup>
                </Col>

              </Row>

              {[CONSTANTS.LOAN_STATUS.REJECT_LOAN].includes(selectedLoanStatusValue) && ( 
                    
                    <Row className="mb-5 apptoval_details_w">     
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-state"
                          >
                            Reject Reason
                          </label>
      
                        <Input disabled={!isEditMode}
                                className="form-control"
                                
                                id="input-reject-reason"
                                placeholder="Reject reason"
                                type="textarea"
                                value={approvalData.rejectReason}
                                onChange={(e) => handleInputChange("rejectReason", e.target.value)}
                                style={{ borderColor: errors.rejectReason ? 'red' : undefined }}
                              />
                              {errors.rejectReason && <div style={{ color: 'red' }}>{errors.rejectReason}</div>}
                        </FormGroup>
                      </Col>
                      </Row>

              )}


              {[CONSTANTS.LOAN_STATUS.APPROVE_LOAN, CONSTANTS.LOAN_STATUS.DISBURSE_LOAN, CONSTANTS.LOAN_STATUS.CLOSE_LOAN, CONSTANTS.LOAN_STATUS.WRITTEN_OFF, CONSTANTS.LOAN_STATUS.RESTRUCTURED].includes(selectedLoanStatusValue) && (
                      <Row className="mb-5 apptoval_details_w">
                        <Col lg="6">
                          <FormGroup>
                          
                            <label className="form-control-label">Approved Amount</label>
                            <Input disabled={!isEditMode || !approvalEdit}
                              type="number"
                              placeholder="Approved amount"
                              value={approvalData.approvedAmount}
                              onChange={(e) => handleInputChange("approvedAmount", e.target.value)}
                              style={{ borderColor: errors.approvedAmount ? 'red' : undefined }}
                            />
                            {errors.approvedAmount && <div style={{ color: 'red' }}>{errors.approvedAmount}</div>}
                          </FormGroup>
                        </Col>

                    

                    <Col lg="6">
                    <FormGroup>
                      <label className="form-control-label">Approved ROI</label>
                      <Input disabled={!isEditMode || !approvalEdit}
                        type="number"
                        placeholder="Approved ROI"
                        value={approvalData.roi}
                        style={{ borderColor: errors.roi ? 'red' : undefined }}
                        onChange={(e) => handleInputChange("roi", e.target.value)}
                      />
                      {errors.roi && <div style={{ color: 'red' }}>{errors.roi}</div>}
                    </FormGroup>
                  </Col>

                  <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label">ROI Type</label>
                        <select disabled={!isEditMode || !approvalEdit} value={approvalData.roiType} onChange={(e) => handleInputChange("roiType", e.target.value)} className="form-control" 
                        id="input-emi-type" name="emi_type">
                          <option value="">--Select --</option>
                          <option value="1">Flat Interest ROI</option>
                          <option value="2">Reducing ROI</option>
                        </select>
                        {errors.roiType && <div style={{ color: 'red' }}>{errors.roiType}</div>}
                      </FormGroup>
                    </Col>

                  <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label">Payment Frequency</label>
                        <select disabled={!isEditMode || !approvalEdit} value={approvalData.paymentFrequency} onChange={(e) => handleInputChange("paymentFrequency", e.target.value)} className="form-control" 
                        id="input-payment-frequency" name="payment_frequency">
                          <option value="">--Select --</option>
                          {repaymentTypeList.map(option => (
                              <option key={option.value_id} value={option.value_id}>
                              {option.status_value}
                            </option>
                          ))}
                        </select>
                        {errors.paymentFrequency && <div style={{ color: 'red' }}>{errors.paymentFrequency}</div>}
                      </FormGroup>
                    </Col>

                  <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label">Approved Tenure {tenureType ? "(In " + tenureType +")" : ""} &nbsp;&nbsp;&nbsp;  
                          {isEditMode ? (
                          <a onClick={getTenureUsingMaxEmi} href='javascript:void(0);'>Calculate using max emi</a> 
                          ) : null }
                        </label>
                        <Input disabled={!isEditMode  || !approvalEdit}
                          type="number"
                          name="approvedAmount"
                          placeholder="Approved Tenure"
                          value={approvalData.approvedTenure}
                          style={{ borderColor: errors.approvedTenure ? 'red' : undefined }}
                          onChange={(e) => handleInputChange("approvedTenure", e.target.value)}
                        />
                        {errors.approvedTenure && <div style={{ color: 'red' }}>{errors.approvedTenure}</div>}
                      </FormGroup>
                    </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Processing Fees Rate</label>
              <Input 
              disabled={!isEditMode  || !approvalEdit}
                type="number"
                placeholder="Processing Fees Rate"
                value={approvalData.processingFeesRate}
                style={{ borderColor: errors.processingFeesRate ? 'red' : undefined }}
                onChange={(e) => handleInputChange("processingFeesRate", e.target.value)}
              />
              {errors.processingFeesRate && <div style={{ color: 'red' }}>{errors.processingFeesRate}</div>}
            </FormGroup>
          </Col>

        <Col lg="6">
  <FormGroup>
    <label className="form-control-label">Other Fees</label>
    <Input 
      disabled={!isEditMode || !approvalEdit}
      type="number"
      placeholder="Other Fees"
      value={approvalData.otherFees}
      style={{ borderColor: errors.otherFees ? 'red' : undefined }}
      onChange={(e) => handleInputChange("otherFees", e.target.value)}
    />
    {/* Optional error message */}
    {/* {errors.otherFees && <div style={{ color: 'red' }}>{errors.otherFees}</div>} */}
  </FormGroup>
</Col>


          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Other Fees Type</label>
              <select disabled={!isEditMode || !approvalEdit} value={approvalData.otherFeesType} onChange={(e) => handleInputChange("otherFeesType", e.target.value)} className="form-control" 
                id="input-oter-fees-type" name="other_fees_type">
                  <option value="">--Select --</option>
                  <option value="1">Other</option>
                  <option value="2">Top-up Loan Fee</option>
                  <option value="3">Registration Charges</option>
                </select>
              {errors.otherFeesType && <div style={{ color: 'red' }}>{errors.otherFeesType}</div>}
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Calculate GST on Other Fees</label>
              <input type="checkbox"
              disabled={!isEditMode || !approvalEdit}
                className="form-control checkbox"
                name="calculateGstOnOtherFees"
                checked={approvalData.calculateGstOnOtherFees || approvalData.calculateGstOnOtherFees === 1}
                style={{ borderColor: errors.calculateGstOnOtherFees ? 'red' : undefined }}
                onChange={handleCheckBoxChange}
              />
              
              {errors.calculateGstOnOtherFees && <div style={{ color: 'red' }}>{errors.calculateGstOnOtherFees}</div>}
            </FormGroup>
          </Col>
          

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Product Code</label>
              <select
              disabled={!isEditMode || !approvalEdit}
                className="form-control"
                value={approvalData.productCode}
                style={{ borderColor: errors.productCode ? 'red' : undefined }}
                onChange={(e) => handleInputChange("productCode", e.target.value)}
              >
                <option value="">--Select Product Code--</option>
                <option value="PL">PL</option>
              </select>
              {errors.productCode && <div style={{ color: 'red' }}>{errors.productCode}</div>}
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Fixed Emi Date  &nbsp;&nbsp;&nbsp;<small>(Leave blank for auto emi date)</small></label><br></br>
              <DatePicker 
              disabled={! (isEditMode && approvalEdit) && selectedLoanStatusValue !== CONSTANTS.LOAN_STATUS.DISBURSE_LOAN }
                dateFormat="YYYY-MM-dd"
                className="form-control"
                selected={approvalData.emiDate}
                style={{ borderColor: errors.emiDate ? 'red' : undefined }}
                onChange={(date) => handleInputChange("emiDate", date)}
                placeholderText="YYYY-MM-DD"
              />
              {errors.emiDate && <div style={{ color: 'red' }}>{errors.emiDate}</div>}
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Disbursal Date &nbsp;&nbsp;&nbsp;<small>(Leave blank for current date)</small></label><br></br>
              <DatePicker 
              disabled={! (isEditMode && approvalEdit) && selectedLoanStatusValue !== CONSTANTS.LOAN_STATUS.DISBURSE_LOAN }
                dateFormat="YYYY-MM-dd"
                className="form-control"
                selected={approvalData.disbursalDate}
                style={{ borderColor: errors.disbursalDate ? 'red' : undefined }}
                onChange={(date) => handleInputChange("disbursalDate", date)}
                placeholderText="YYYY-MM-DD"
              />
              {errors.disbursalDate && <div style={{ color: 'red' }}>{errors.disbursalDate}</div>}
            </FormGroup>
          </Col>    
              <Col  lg="12">
                <Button
                      color="primary"
                      href="javascript:void(0)"
                      onClick={handleViewEmiClick}
                      size="md"
                    >
                      View Emi Schedule
                    </Button>

              </Col>

            </Row>
            )}
              <Row className="">     
                <Col lg="12">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-state"
                    >
                      Comment
                    </label>

                    <Input disabled={!isEditMode}
                    value={approvalData.remark}
                      className="form-control"
                      id="input-comment"
                      placeholder="Comment"
                      type="textarea"
                      style={{ borderColor: errors.remark ? 'red' : undefined }}
                      onChange={(e) => handleInputChange("remark", e.target.value)}
                    />
                    
                    {errors.remark && <div style={{ color: 'red' }}>{errors.remark}</div>}
                    <div className="mt-4">
                        <a href="javascript:void(0)" onClick={showComments}>
                        View Remarks
                      </a>
                    </div>

                  </FormGroup>
                </Col>

              </Row>


              <Row className="">     
                <Col lg="12">

                {isEditMode ? (
                    <>
                    <Button color="primary" size="md" onClick={handleSave}>
                      Save
                    </Button>

                    <Button
                      color=""
                      href="#"
                      onClick={handleCancel}
                      size="md"
                    >
                      Cancel
                    </Button>
                    </>
                    ) : (

                      <Button
                      color="primary"
                      href="#"
                      onClick={handleEdit}
                      size="md"
                    >
                      Edit
                    </Button>
                      
                    )}
                </Col>

              </Row>

              </CardBody>
            </Card>
          )}
    </>
  );
};

export default Credit;